/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { ProductConstants } from '../actions/actionType';

export function ViewOffer(state = {}, action) {
    switch (action.type) {
    case ProductConstants.OFFER_DETAILS_SUCCESS:
        return {
            type: ProductConstants.OFFER_DETAILS_SUCCESS,
            items: action.obj,
        };
    case ProductConstants.OFFER_DETAILS_FAILURE:
        return {
            type: ProductConstants.OFFER_DETAILS_SUCCESS,
            message: action.message,
        };
    case ProductConstants.CART_SELECTED_ITEM:
        return {...state,
            selected:action.user.data
                
        };
        
    default:
        return state;
    }
}
